import React from 'react';

import { LessonTypeSelect } from 'components/LessonTypeSelect';

const LessonTypeSelectField = ({
  field,
  form,
  ...restProps
}: { field: any; form: any } & Record<string, any>) => {
  const handleChange = (nextValue: any) => {
    form.setFieldValue(field.name, nextValue);
  };

  return <LessonTypeSelect {...field} {...restProps} onChange={handleChange} />;
};

export default React.memo(LessonTypeSelectField) as any;
